import axios from 'axios';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import {Navigate, useNavigate } from 'react-router-dom'
import { register } from '../../Slices/cart/auth/Auth';

function Login() {
  const token = localStorage.getItem('token');
  const [selectedProvince, setSelectedProvince] = useState('');
  const [zipCodes, setZipCodes] = useState([]);
  const [isClick, setIsClick] = useState(false);
  const [Login, setLogin] = useState({
    email: '',
    password: '',
    errorlist: []
  });
  
  const handleInputLogin = (e) => {
    e.persist();
    setLogin({ ...Login, [e.target.name]: e.target.value });
  }
  
  const handleSubmitLogin = (e) => {
    e.preventDefault();
    setIsClick(true);
    const data = {
      email: Login.email,
      password: Login.password
    }
    
    axios.get('/sanctum/csrf-cookie').then(response => {
      axios.post('/api/login', data).then(res => {
        if (res.data.status === 200) {
          dispatch(register(res.data));
          if (res.data.type === 'Admin') {
            navigate('/dashboard/addproduct');
          } else {
            navigate('/viewcart');
          }
        } else if (res.data.status === 401) {
         // alert('Invalid credentials. Please try again.');
          setLogin({ ...Login, errorlist: { general: 'Invalid email or password' } });
        } else {
          setLogin({ ...Login, errorlist: res.data.validation_errors });
        }
        setIsClick(false);
      }).catch(err => {
        setIsClick(false);
        setLogin({ ...Login, errorlist: { general: 'Connection error. Please try again.' } });
      });
    });
  }
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [status, setStatus] = useState(true);
  const [registerInput, setRegisterInput] = useState({
    name: '',
    lname: '',
    address: '',
    city: '',
    phone: '',
    email: '',
    password: '',
    zipcode: '',
    error_list: []
  });
  
  const canadianProvincesAndTerritories = [
    { code: 'Pun', name: 'Punjab' },
    { code: 'Sin', name: 'Sindh' },
    { code: 'Kpk', name: 'KPK' },
    { code: 'Bal', name: 'Balochistan' },
  ];
  
  const fetchZipCodes = async (province) => {
    try {
      const response = await axios.get(`api/shippingzones/all/${province}`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching shipping zones:', error);
      return [];
    }
  };
  
  const fetchData = async (selectedProvince) => {
    if (selectedProvince) {
      const zipCodesForProvince = await fetchZipCodes(selectedProvince);
      setZipCodes(zipCodesForProvince);
      if (zipCodesForProvince.length > 0) {
        setRegisterInput({ ...registerInput, zipcode: zipCodesForProvince[0].zipcode });
      }
    } else {
      setZipCodes([]);
    }
  };
  
  const handleProvinceChange = (e) => {
    setSelectedProvince(e.target.value);
    fetchData(e.target.value);
  };
  
  const handleInput = (e) => {
    e.persist();
    setRegisterInput({ ...registerInput, [e.target.name]: e.target.value });
  }
  
  const handleSubmit = (e) => {
    setIsClick(true);
    e.preventDefault();
    const data = {
      email: registerInput.email,
      password: registerInput.password,
      name: registerInput.name,
      lname: registerInput.lname,
      city: registerInput.city,
      address: registerInput.address,
      phone: registerInput.phone,
      province: selectedProvince,
      zipcode: registerInput.zipcode
    }
    
    axios.get('/sanctum/csrf-cookie').then(res => {
      axios.post(`/api/register`, data).then(res => {
        if (res.data.status === 200) {
          dispatch(register(res.data));
          setIsClick(false);
          navigate('/viewcart');
        } else {
          setRegisterInput({ ...registerInput, error_list: res.data.validation_errors })
          setIsClick(false);
        }
      }).catch(err => {
        setIsClick(false);
        setRegisterInput({ ...registerInput, error_list: { general: 'Registration failed. Please try again.' } });
      });
    });
  }
  
  if (token) {
    return (<Navigate to='/' />)
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 items-center justify-center min-h-[calc(100vh-6rem)]">
          
          {/* Form Section */}
          <div className="w-full lg:w-[70%] xl:w-[60%]">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden backdrop-blur-sm bg-white/95">
              <div className="bg-gradient-to-r from-red-500 to-orange-500 px-8 py-4">
                <h2 className="text-2xl font-bold text-white">
                  {status ? 'Welcome Back!' : 'Create New Account'}
                </h2>
                <p className="text-red-100 text-sm mt-1">
                  {status ? 'Login to continue shopping' : 'Join Apna Bachat Bazar family'}
                </p>
              </div>
              
              <div className="p-8 md:p-10">
                {status ? (
                  /* LOGIN FORM */
                  <div>
                    <div className="text-center mb-8">
                      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-r from-red-100 to-orange-100 mb-4">
                        <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                      </div>
                      <h3 className="text-gray-600">Welcome back! Please login to your account</h3>
                    </div>
                    
                    {/* General Error Display */}
                    {Login.errorlist?.general && (
                      <div className="mb-4 p-3 bg-red-50 border-l-4 border-red-500 rounded-lg">
                        <p className="text-red-700 text-sm">{Login.errorlist.general}</p>
                      </div>
                    )}
                    
                    <div className="space-y-6">
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          📧 Email Address
                        </label>
                        <input 
                          name='email' 
                          onChange={(e) => handleInputLogin(e)} 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all duration-200 outline-none ${
                            Login.errorlist?.email ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-red-500'
                          } focus:ring-2 focus:ring-red-200`}
                          placeholder="Enter your registered email"
                        />
                        {Login.errorlist?.email && (
                          <p className="text-red-500 text-xs mt-1 flex items-center gap-1">
                            <span>⚠️</span> {Login.errorlist.email[0]}
                          </p>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          🔒 Password
                        </label>
                        <input 
                          name='password' 
                          onChange={(e) => handleInputLogin(e)} 
                          type='password' 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all duration-200 outline-none ${
                            Login.errorlist?.password ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-red-500'
                          } focus:ring-2 focus:ring-red-200`}
                          placeholder="Enter your password"
                        />
                        {Login.errorlist?.password && (
                          <p className="text-red-500 text-xs mt-1 flex items-center gap-1">
                            <span>⚠️</span> {Login.errorlist.password[0]}
                          </p>
                        )}
                      </div>
                      
                      <button 
                        onClick={(e) => handleSubmitLogin(e)} 
                        disabled={isClick}
                        className="w-full bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {isClick ? (
                          <span className="flex items-center justify-center gap-2">
                            <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Logging in...
                          </span>
                        ) : 'Login'}
                      </button>
                    </div>
                  </div>
                ) : (
                  /* REGISTER FORM */
                  <div>
                    <div className="text-center mb-6">
                      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-r from-green-100 to-emerald-100 mb-4">
                        <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                        </svg>
                      </div>
                      <h3 className="text-gray-600">Join us and start saving today!</h3>
                    </div>
                    
                    {/* General Error Display */}
                    {registerInput.error_list?.general && (
                      <div className="mb-4 p-3 bg-red-50 border-l-4 border-red-500 rounded-lg">
                        <p className="text-red-700 text-sm">{registerInput.error_list.general}</p>
                      </div>
                    )}
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">👤 First Name</label>
                        <input 
                          name='name' 
                          onChange={(e) => handleInput(e)} 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none ${
                            registerInput.error_list?.name ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                          placeholder="Enter your first name"
                        />
                        {registerInput.error_list?.name && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.name[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">📝 Last Name</label>
                        <input 
                          name='lname' 
                          onChange={(e) => handleInput(e)} 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none ${
                            registerInput.error_list?.lname ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                          placeholder="Enter your last name"
                        />
                        {registerInput.error_list?.lname && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.lname[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">📞 Phone Number</label>
                        <input 
                          name='phone' 
                          onChange={(e) => handleInput(e)} 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none ${
                            registerInput.error_list?.phone ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                          placeholder="Enter your phone number"
                        />
                        {registerInput.error_list?.phone && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.phone[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">🏙️ City</label>
                        <input 
                          name='city' 
                          onChange={(e) => handleInput(e)} 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none ${
                            registerInput.error_list?.city ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                          placeholder="Enter your city"
                        />
                        {registerInput.error_list?.city && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.city[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">📍 Province</label>
                        <select
                          id="province"
                          name="province"
                          value={selectedProvince}
                          onChange={handleProvinceChange}
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none bg-white cursor-pointer ${
                            registerInput.error_list?.province ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                        >
                          <option value="">-- Select Province --</option>
                          {canadianProvincesAndTerritories.map((province) => (
                            <option key={province.code} value={province.code}>
                              {province.name}
                            </option>
                          ))}
                        </select>
                        {registerInput.error_list?.province && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.province[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">📮 Zip Code</label>
                        <select
                          id="zipCode"
                          name="zipcode"
                          value={registerInput.zipcode}
                          onChange={(e) => handleInput(e)}
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none bg-white cursor-pointer ${
                            registerInput.error_list?.zipcode ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                        >
                          <option value="">-- Select Zip Code --</option>
                          {zipCodes.map((zip) => (
                            <option key={zip.id} value={zip.id}>
                              {zip.zipcode}
                            </option>
                          ))}
                        </select>
                        {registerInput.error_list?.zipcode && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.zipcode[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div className="md:col-span-2">
                        <label className="block text-sm font-bold text-gray-700 mb-2">🏠 Full Address</label>
                        <textarea 
                          name='address' 
                          onChange={(e) => handleInput(e)} 
                          rows="2"
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none resize-none ${
                            registerInput.error_list?.address ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                          placeholder="Enter your complete address"
                        />
                        {registerInput.error_list?.address && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.address[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">📧 Email Address</label>
                        <input 
                          name='email' 
                          onChange={(e) => handleInput(e)} 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none ${
                            registerInput.error_list?.email ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                          placeholder="Enter your email"
                        />
                        {registerInput.error_list?.email && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.email[0]}
                            </p>
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">🔒 Password</label>
                        <input 
                          name='password' 
                          onChange={(e) => handleInput(e)} 
                          type='password' 
                          className={`w-full px-4 py-3 border-2 rounded-xl transition-all outline-none ${
                            registerInput.error_list?.password ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-gray-200 focus:border-green-500'
                          } focus:ring-2 focus:ring-green-200`}
                          placeholder="Create a password"
                        />
                        {registerInput.error_list?.password && (
                          <div className="mt-1 p-2 bg-red-50 rounded-md">
                            <p className="text-red-500 text-xs flex items-center gap-1">
                              <span>⚠️</span> {registerInput.error_list.password[0]}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    
                    <button 
                      onClick={handleSubmit} 
                      disabled={isClick}
                      className="w-full mt-8 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isClick ? (
                        <span className="flex items-center justify-center gap-2">
                          <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Creating Account...
                        </span>
                      ) : 'Create Account'}
                    </button>
                  </div>
                )}
                
                {/* Toggle between Login & Register */}
                <div className="mt-8 text-center">
                  {status ? (
                    <button onClick={() => setStatus(false)} className="text-green-600 hover:text-green-700 font-semibold transition-colors">
                      🆕 New to Apna Bachat Bazar? Create an account →
                    </button>
                  ) : (
                    <button onClick={() => setStatus(true)} className="text-red-600 hover:text-red-700 font-semibold transition-colors">
                      🔐 Already have an account? Login here →
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          {/* Image/Illustration Section */}
          <div className="hidden lg:block lg:w-[30%] xl:w-[35%]">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-orange-500/10 rounded-full blur-3xl"></div>
              <img 
                alt='Shopping illustration' 
                className='relative w-full h-auto object-contain animate-float' 
                src='images/login.png'
              />
              <div className="absolute bottom-10 left-0 right-0 text-center">
                <div className="inline-block bg-white/90 backdrop-blur-sm rounded-full px-6 py-3 shadow-lg">
                  <p className="text-gray-800 font-semibold">✨ Join 50,000+ Happy Customers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  )
}

export default Login